// The bot traits an admin can tune: what each one is, and the range it may take.
// One list for the admin leaderboard's editor (labels, sliders) and the server's
// validation of what it saves. The planner's own reading of the traits is in
// path-checker-ai-handler.js (see docs/design/bots/PERSONALITIES.md).
//
// `skill` traits are how GOOD a bot is and always apply. `personality` traits
// are how it likes to play; a crowd level with personalities off ignores them.
// `label` is the full name (the editor, hover text); `short`, where given, is what
// a narrow table header shows.
// `unset`: what the planner assumes when a bot doesn't carry the trait at all.
// Ranges match what the planner accepts (the bot trait lab uses the same).
export var BOT_TRAITS = [
    { key: "planning",   label: "Planning depth",   short: "Depth",        min: 0,  max: 1, step: 0.05, unset: 0.7, kind: "skill",       blurb: "How far ahead it looks: 1.8 seconds at 0, 2.7 seconds at 1. (How many options it weighs is planning breadth.)" },
    { key: "breadth",    label: "Planning breadth", short: "Breadth",      min: 0,  max: 1, step: 0.05, unset: 1,   kind: "skill",       blurb: "How many turn options it weighs each time it thinks: 3 at 0 (straight on and a gentle turn each way) up to all 9 at 1. The strongest lever on how long a bot survives." },
    { key: "precision",  label: "Precision",  min: 0,  max: 1, step: 0.05, unset: 0.7, kind: "skill",       blurb: "How well it executes: it re-plans every 75 ms at 0 down to 50 ms at 1, and its steering lands up to 100 ms late at 0, on time at 1." },
    { key: "caution",    label: "Caution",    min: -1, max: 1, step: 0.05, unset: 0,   kind: "personality", blurb: "Positive keeps clearance and avoids getting boxed in. Negative is a daredevil that skims walls and trails." },
    { key: "aggression", label: "Aggression", min: -1, max: 1, step: 0.05, unset: 0,   kind: "personality", blurb: "Positive cuts across an opponent's projected path. Negative keeps its distance from opponents." },
    { key: "greed",      label: "Power-up greed", short: "PU greed", min: -1, max: 1, step: 0.05, unset: 0,   kind: "personality", blurb: "Pull toward power-ups. WHICH ones is the same for every bot: the global power-up values (0 = ignored, 1 = full pull), then who the effect hits and who gets there first. Negative avoids them." },
    { key: "space",      label: "Space",      min: -1, max: 1, step: 0.05, unset: 0,   kind: "personality", blurb: "Preference for paths that keep the most open room reachable. Negative heads for tight spots." },
];

export function botTrait(key) {
    for (var i = 0; i < BOT_TRAITS.length; i++) { if (BOT_TRAITS[i].key === key) { return BOT_TRAITS[i]; } }
    return null;
}

// A saved trait set, made safe: known traits only, numbers only, clamped to their
// range and rounded to 2 decimals. Returns null when nothing valid is left.
export function cleanTraits(input) {
    if (!input || typeof input !== "object") { return null; }
    var out = {};
    var any = false;
    BOT_TRAITS.forEach(function (t) {
        var v = input[t.key];
        if (typeof v !== "number" || !isFinite(v)) { return; }
        out[t.key] = Math.round(Math.min(t.max, Math.max(t.min, v)) * 100) / 100;
        any = true;
    });
    return any ? out : null;
}
